/** Quick picks; anything else can be typed or pasted from the keyboard. */
export const QUICK_EMOJIS = [
  "😀",
  "😎",
  "🥳",
  "😇",
  "🤓",
  "🥰",
  "😴",
  "🤠",
  "🐶",
  "🐱",
  "🐻",
  "🦊",
  "🐼",
  "🐯",
  "🐸",
  "🦄",
  "🐧",
  "🐵",
  "🐰",
  "🐷",
  "🦁",
  "🐙",
  "🐢",
  "🦋",
  "🍕",
  "🍔",
  "🍜",
  "🍣",
  "🍩",
  "🍺",
  "☕",
  "🍓",
  "⚽",
  "🎮",
  "🎸",
  "🚀",
  "🌈",
  "🔥",
  "⭐",
  "💎",
];

const EMOJI_PATTERN =
  /\p{Extended_Pictographic}|\p{Regional_Indicator}|\u20E3/u;
const graphemes = new Intl.Segmenter(undefined, { granularity: "grapheme" });

/** Mirrors the API check: exactly one grapheme, and an emoji (not a digit or letter). */
export function isSingleEmoji(value: string): boolean {
  return (
    [...graphemes.segment(value)].length === 1 && EMOJI_PATTERN.test(value)
  );
}
